import {List} from 'immutable';

type elemType<T> = List<T | undefined | null> | Array<T | undefined | null>;

/**
 * Returns a List with null/undefined elements excluded
 */
export default function ListOfNotNull<T>(elements: Array<T | undefined | null>): List<T>;
export default function ListOfNotNull<T>(elements: List<T | undefined | null>): List<T>;
export default function ListOfNotNull<T>(elements: elemType<T | undefined | null>): List<T> {
  // @ts-ignore
  return List(elements.filter(el => el != null)) as List<T>;
}
